import { ConditionalNodeItem } from "./ConditionalNodeItem";

export function MultipleCriteriaConditionalNodeItem({
    formValues = {},
    triggeringEvent,
}: {
    formValues: Record<string, any>;
    triggeringEvent: { eventType?: string; eventName?: string };
}): JSX.Element {
    // creating a new component since this component will be expanded to support a Form.List containing multiple conditions
    // this way will be easier to clear up previous implementation
    return <ConditionalNodeItem formValues={formValues} triggeringEvent={triggeringEvent} />;
}
